import { APP_ENABLE_FLIPS, APP_CLEAR_SURROGATE_KEY } from 'actions/app';

const DEFAULT_STATE = {
  flips: [],
  surrogateKey: undefined
};

export default function app(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case APP_ENABLE_FLIPS:
      return { ...state, flips: [...state.flips, ...action.flips] };
    case APP_CLEAR_SURROGATE_KEY:
      return { ...state, surrogateKey: undefined };
    default:
      return state;
  }
}
